import React from "react";

import { Checkbox } from "../../checkbox";
import { Props } from "./types";
import styles from "./styles.scss";

function Task({ task, isSelected, onSelect }: Props) {
  return (
    <div className={styles.task} onClick={onSelect}>
      <Checkbox isChecked={isSelected} />
      <p className={styles.name}>{task.name}</p>
    </div>
  );
}

export { Task };
